<template>
  <section class="section gameSection">
    <div class="header">
      <div class="backBtn" v-on:click="goBack"></div>
      <h4>{{title}}</h4>
    </div>
    <div class="menuCnt">
      <div class="wrongAnswerCnt" :class="{open: wrongAnswerAn}"
        v-if="wrongAnswer" v-on:click="resetWrong">
        <div class="wrongIn">
          <img src="../assets/menolak.png">
          <h4>Ops.. Kombinasinya salah!<br />Coba yang lain</h4>
        </div>
      </div>
      <div class="menuItem loading" v-if="loading">
        <div class="loadingPrice"></div>
      </div>
      <div class="menuItem report" v-else>
        <div class="gameHeader">
          <div class="menuBtn"></div>
          <div class="progressCnt">
            <div class="progress" :style="{'width': `${score / 100 * 100}%`}"></div>
          </div>
          <div class="scoreCnt">
            <div class="scoreLabel">Score</div>
            <div class="score">{{parseInt(score, 10)}}pt</div>
          </div>
        </div>
        <div class="gameItemCnt" ref="gameCnt">
          <div class="mouseMover" v-on:mousemove="mouseMoved"
            v-on:mouseup="mouseLeaved" v-on:mouseleave="mouseLeaved"
            v-if="gameStarted" ref="mouseMover"></div>
          <svg height="210" width="500">
            <line :x1="gamePos.l1.x" :y1="gamePos.l1.y"
              :x2="currentMouse.x" :y2="currentMouse.y"
              style="stroke-width:6;"
              v-if="currentGame === 1 && currentGameLr === 'l'"/>
            <line :x2="gamePos.r1.x" :y2="gamePos.r1.y"
              :x1="currentMouse.x" :y1="currentMouse.y"
              style="stroke-width:6;"
              v-else-if="currentGame === 1 && currentGameLr === 'r'"/>

            <line :x1="gamePos.l2.x" :y1="gamePos.l2.y"
              :x2="currentMouse.x" :y2="currentMouse.y"
              style="stroke-width:6;"
              v-if="currentGame === 2 && currentGameLr === 'l'"/>
            <line :x2="gamePos.r2.x" :y2="gamePos.r2.y"
              :x1="currentMouse.x" :y1="currentMouse.y"
              style="stroke-width:6;"
              v-else-if="currentGame === 2 && currentGameLr === 'r'"/>

            <line :x1="gamePos.l3.x" :y1="gamePos.l3.y"
              :x2="currentMouse.x" :y2="currentMouse.y"
              style="stroke-width:6;"
              v-if="currentGame === 3 && currentGameLr === 'l'"/>
            <line :x2="gamePos.r3.x" :y2="gamePos.r3.y"
              :x1="currentMouse.x" :y1="currentMouse.y"
              style="stroke-width:6;"
              v-else-if="currentGame === 3 && currentGameLr === 'r'"/>

            <line :x1="gamePos.l4.x" :y1="gamePos.l4.y"
              :x2="currentMouse.x" :y2="currentMouse.y"
              style="stroke-width:6;"
              v-if="currentGame === 4 && currentGameLr === 'l'"/>
            <line :x2="gamePos.r4.x" :y2="gamePos.r4.y"
              :x1="currentMouse.x" :y1="currentMouse.y"
              style="stroke-width:6;"
              v-else-if="currentGame === 4 && currentGameLr === 'r'"/>

            <line :x1="gamePos.l1.x" :y1="gamePos.l1.y"
              :x2="gameAnswered.g1.x" :y2="gameAnswered.g1.y"
              style="stroke-width:6;" :class="{answerRight: gameAnswered.g1.answer,
                answerWrong: !gameAnswered.g1.answer}"
              v-if="gameAnswered.g1.status"/>
            <line :x1="gamePos.l2.x" :y1="gamePos.l2.y"
              :x2="gameAnswered.g2.x" :y2="gameAnswered.g2.y"
              style="stroke-width:6;" :class="{answerRight: gameAnswered.g2.answer,
                answerWrong: !gameAnswered.g2.answer}"
              v-if="gameAnswered.g2.status"/>
            <line :x1="gamePos.l3.x" :y1="gamePos.l3.y"
              :x2="gameAnswered.g3.x" :y2="gameAnswered.g3.y"
              style="stroke-width:6;" :class="{answerRight: gameAnswered.g3.answer,
                answerWrong: !gameAnswered.g3.answer}"
              v-if="gameAnswered.g3.status"/>
            <line :x1="gamePos.l4.x" :y1="gamePos.l4.y"
              :x2="gameAnswered.g4.x" :y2="gameAnswered.g4.y"
              style="stroke-width:6;" :class="{answerRight: gameAnswered.g4.answer,
                answerWrong: !gameAnswered.g4.answer}"
              v-if="gameAnswered.g4.status"/>
          </svg>
          <div class="gameItem" v-if="gameItems[0]">
            <div class="gameItem1 gmImg"
              :class="{rightAnswer: gameAnswered.g1.answer,
              wrongAnswer: gameAnswered.g1.status && !gameAnswered.g1.answer}">
              <div class="theImg canZoom" v-if="gameItems[0].media"
                :style="{'background-image': `url(${gameItems[0].media.imageSm})`}"
                v-on:click="zoomImg(0)">
                <div v-if="gameItems[0].mediaLabel" class="mediaLabel">
                  {{gameItems[0].mediaLabel}}
                </div>
              </div>
              <div class="theImg noImg" v-else>
                <div v-if="gameItems[0].mediaLabel" class="mediaLabel">
                  {{gameItems[0].mediaLabel}}
                </div>
              </div>
              <div class="gameHandle" :class="{hover: gamePos.l1.hover}"
                v-on:mousedown="startGame('l', 1)" v-on:touchstart="startGame('l', 1)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"></div>
            </div>
            <div class="gameItem1 gameItem2 gmImg"
              :class="{rightAnswer: (gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r1')
              || (gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r1')
              || (gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r1')
              || (gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r1'),
              wrongAnswer: (!gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r1')
              || (!gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r1')
              || (!gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r1')
              || (!gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r1')}">
              <div class="gameHandle" :class="{hover: gamePos.r1.hover}"
                v-on:mousedown="startGame('r', 1)" v-on:touchstart="startGame('r', 1)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"
                ref="r1"></div>
              <div class="theImg" :class="{smallFont: words[0].sf}"
                v-html="words[0].aw"></div>
            </div>
          </div>
          <div class="gameItem" v-if="gameItems[1]">
            <div class="gameItem1 gmImg"
              :class="{rightAnswer: gameAnswered.g2.answer,
              wrongAnswer: gameAnswered.g2.status && !gameAnswered.g2.answer}">
              <div class="theImg canZoom" v-if="gameItems[1].media"
                :style="{'background-image': `url(${gameItems[1].media.imageSm})`}"
                v-on:click="zoomImg(1)">
                <div v-if="gameItems[1].mediaLabel" class="mediaLabel">
                  {{gameItems[1].mediaLabel}}
                </div>
              </div>
              <div class="theImg noImg" v-else>
                <div v-if="gameItems[1].mediaLabel" class="mediaLabel">
                  {{gameItems[1].mediaLabel}}
                </div>
              </div>
              <div class="gameHandle" :class="{hover: gamePos.l2.hover}"
                v-on:mousedown="startGame('l', 2)" v-on:touchstart="startGame('l', 2)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"></div>
            </div>
            <div class="gameItem1 gameItem2 gmImg"
              :class="{rightAnswer: (gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r2')
              || (gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r2')
              || (gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r2')
              || (gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r2'),
              wrongAnswer: (!gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r2')
              || (!gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r2')
              || (!gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r2')
              || (!gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r2')}">
              <div class="gameHandle" :class="{hover: gamePos.r2.hover}"
                v-on:mousedown="startGame('r', 2)" v-on:touchstart="startGame('r', 2)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"
                ref="r2"></div>
              <div class="theImg" :class="{smallFont: words[1].sf}"
                v-html="words[1].aw"></div>
            </div>
          </div>
          <div class="gameItem" v-if="gameItems[2]">
            <div class="gameItem1 gmImg"
              :class="{rightAnswer: gameAnswered.g3.answer,
              wrongAnswer: gameAnswered.g3.status && !gameAnswered.g3.answer}">
              <div class="theImg canZoom" v-if="gameItems[2].media"
                :style="{'background-image': `url(${gameItems[2].media.imageSm})`}"
                v-on:click="zoomImg(2)">
                <div v-if="gameItems[2].mediaLabel" class="mediaLabel">
                  {{gameItems[2].mediaLabel}}
                </div>
              </div>
              <div class="theImg noImg" v-else>
                <div v-if="gameItems[2].mediaLabel" class="mediaLabel">
                  {{gameItems[2].mediaLabel}}
                </div>
              </div>
              <div class="gameHandle" :class="{hover: gamePos.l3.hover}"
                v-on:mousedown="startGame('l', 3)" v-on:touchstart="startGame('l', 3)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"></div>
            </div>
            <div class="gameItem1 gameItem2 gmImg"
              :class="{rightAnswer: (gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r3')
              || (gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r3')
              || (gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r3')
              || (gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r3'),
              wrongAnswer: (!gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r3')
              || (!gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r3')
              || (!gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r3')
              || (!gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r3')}">
              <div class="gameHandle" :class="{hover: gamePos.r3.hover}"
                v-on:mousedown="startGame('r', 3)" v-on:touchstart="startGame('r', 3)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"
                ref="r3"></div>
              <div class="theImg" :class="{smallFont: words[2].sf}"
                v-html="words[2].aw"></div>
            </div>
          </div>
          <div class="gameItem" v-if="gameItems[3]">
            <div class="gameItem1 gmImg"
              :class="{rightAnswer: gameAnswered.g4.answer,
              wrongAnswer: gameAnswered.g4.status && !gameAnswered.g4.answer}">
              <div class="theImg canZoom" v-if="gameItems[3].media"
                :style="{'background-image': `url(${gameItems[3].media.imageSm})`}"
                v-on:click="zoomImg(3)">
                <div v-if="gameItems[3].mediaLabel" class="mediaLabel">
                  {{gameItems[3].mediaLabel}}
                </div>
              </div>
              <div class="theImg noImg" v-else>
                <div v-if="gameItems[3].mediaLabel" class="mediaLabel">
                  {{gameItems[3].mediaLabel}}
                </div>
              </div>
              <div class="gameHandle" :class="{hover: gamePos.l4.hover}"
                v-on:mousedown="startGame('l', 4)" v-on:touchstart="startGame('l', 4)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"></div>
            </div>
            <div class="gameItem1 gameItem2 gmImg"
              :class="{rightAnswer: (gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r4')
              || (gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r4')
              || (gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r4')
              || (gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r4'),
              wrongAnswer: (!gameAnswered.g1.answer
              && gameAnswered.g1.answerPos === 'r4')
              || (!gameAnswered.g2.answer && gameAnswered.g2.answerPos === 'r4')
              || (!gameAnswered.g3.answer && gameAnswered.g3.answerPos === 'r4')
              || (!gameAnswered.g4.answer && gameAnswered.g4.answerPos === 'r4')}">
              <div class="gameHandle" :class="{hover: gamePos.r4.hover}"
                v-on:mousedown="startGame('r', 4)" v-on:touchstart="startGame('r', 4)"
                v-on:touchmove="mouseMoved" v-on:touchend="mouseLeaved"
                ref="r4"></div>
              <div class="theImg" :class="{smallFont: words[3].sf}"
                v-html="words[3].aw"></div>
            </div>
          </div>
        </div>
        <div class="gameFooter">
          <!-- <button class="btn">Sebelumnya</button> -->
          <button class="btn" :class="{disabled: score < 100, btnLoading: btnLoading}"
            v-on:click="closeGame">
            <span>Selesai</span>
          </button>
        </div>
      </div>
    </div>
    <Snackbar ref="snackbar"/>
    <ImageZoomer ref="imageZoomer"/>
  </section>
</template>

<script>
import Snackbar from '@/components/Snackbar.vue';
import ImageZoomer from '@/components/ImageZoomer.vue';

export default {
  name: 'home',
  components: { Snackbar, ImageZoomer },
  data() {
    return {
      title: '...',
      loading: true,
      btnLoading: false,

      score: 0,
      gameStarted: false,
      currentMouse: { x: 0, y: 0 },
      currentGame: 0,
      currentGameLr: '',
      currentAnswer: null,
      wrongAnswer: false,
      wrongAnswerAn: false,
      gameAnswered: {
        g1: {
          status: false,
          answer: false,
          answerPos: '',
          x: 0,
          y: 0,
        },
        g2: {
          status: false,
          answer: false,
          answerPos: '',
          x: 0,
          y: 0,
        },
        g3: {
          status: false,
          answer: false,
          answerPos: '',
          x: 0,
          y: 0,
        },
        g4: {
          status: false,
          answer: false,
          answerPos: '',
          x: 0,
          y: 0,
        },
      },
      gamePos: {
        l1: { x: 122, y: 50, hover: false },
        r1: { x: 298, y: 50, hover: false },
        l2: { x: 122, y: 166, hover: false },
        r2: { x: 298, y: 166, hover: false },
        l3: { x: 122, y: 282, hover: false },
        r3: { x: 298, y: 282, hover: false },
        l4: { x: 122, y: 398, hover: false },
        r4: { x: 298, y: 398, hover: false },
      },
      gameItems: [],
      words: [],

      /**
       * Sound
       *
       */
      okSound: null,
      errorSound: null,
    };
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    doNothing() {},
    closeGame() {
      if (this.score < 100 || this.btnLoading) return;
      this.$router.back();
      // window.location.href = `/mission/day/${}`;
    },
    goBack() {
      this.$router.back();
      // window.location.href = `/mission/day/${}`;
    },
    zoomImg(i) {
      this.$refs.imageZoomer.open(this.gameItems[i]);
    },
    resetWrong() {
      this.wrongAnswerAn = false;
      setTimeout(() => {
        this.wrongAnswer = false;
        if (this.gameAnswered.g1.status && !this.gameAnswered.g1.answer) {
          this.gameAnswered.g1.status = false;
          this.gameAnswered.g1.answerPos = '';
        }
        if (this.gameAnswered.g2.status && !this.gameAnswered.g2.answer) {
          this.gameAnswered.g2.status = false;
          this.gameAnswered.g2.answerPos = '';
        }
        if (this.gameAnswered.g3.status && !this.gameAnswered.g3.answer) {
          this.gameAnswered.g3.status = false;
          this.gameAnswered.g3.answerPos = '';
        }
        if (this.gameAnswered.g4.status && !this.gameAnswered.g4.answer) {
          this.gameAnswered.g4.status = false;
          this.gameAnswered.g4.answerPos = '';
        }
      }, 300);
    },
    startGame(pos, idx) {
      if (pos === 'l' && this.gameAnswered[`g${idx}`].status) return;
      if (pos === 'r' && (this.gameAnswered.g1.answerPos === `${pos}${idx}`
        || this.gameAnswered.g2.answerPos === `${pos}${idx}`
        || this.gameAnswered.g3.answerPos === `${pos}${idx}`
        || this.gameAnswered.g4.answerPos === `${pos}${idx}`)) {
        return;
      }
      this.currentGameLr = pos;
      this.currentMouse.x = this.gamePos[`${pos}${idx}`].x;
      this.currentMouse.y = this.gamePos[`${pos}${idx}`].y;
      this.currentGame = idx;
      this.gameStarted = `${pos}${idx}`;
      document.getElementsByTagName('BODY')[0].classList.add('noScroll');
    },
    mouseLeaved() {
      this.clearHover();
      if (!this.gameStarted) return;
      let gameAnswer = false;
      if (this.currentAnswer) {
        if (this.currentAnswer.substr(0, 1) === 'l'
          && this.gameAnswered[`g${this.currentAnswer.substr(1, 1)}`].status) {
          this.stopGame();
          return;
        }
        if (this.currentAnswer.substr(0, 1) === 'r'
          && (this.gameAnswered.g1.answerPos === this.currentAnswer
          || this.gameAnswered.g2.answerPos === this.currentAnswer
          || this.gameAnswered.g3.answerPos === this.currentAnswer
          || this.gameAnswered.g4.answerPos === this.currentAnswer)) {
          this.stopGame();
          return;
        }
        if (this.currentAnswer.substr(0, 1) === this.currentGameLr) return;
        if (this.gameStarted.substr(0, 1) === 'l') {
          const gIdx = parseInt(this.gameStarted.substr(1, 1), 10);
          const aIdx = parseInt(this.currentAnswer.substr(1, 1), 10);
          gameAnswer = this.gameItems[gIdx - 1].answer === this.words[aIdx - 1].aw;
          this.gameAnswered[`g${gIdx}`].status = true;
          this.gameAnswered[`g${gIdx}`].answer = gameAnswer;
          this.gameAnswered[`g${gIdx}`].x = this.currentMouse.x;
          this.gameAnswered[`g${gIdx}`].y = this.currentMouse.y;
          this.gameAnswered[`g${gIdx}`].answerPos = this.currentAnswer;
        } else {
          const gIdx = parseInt(this.currentAnswer.substr(1, 1), 10);
          const aIdx = parseInt(this.gameStarted.substr(1, 1), 10);
          gameAnswer = this.gameItems[gIdx - 1].answer === this.words[aIdx - 1].aw;
          this.gameAnswered[`g${gIdx}`].status = true;
          this.gameAnswered[`g${gIdx}`].answer = gameAnswer;
          this.gameAnswered[`g${gIdx}`].x = this.gamePos[this.gameStarted].x;
          this.gameAnswered[`g${gIdx}`].y = this.gamePos[this.gameStarted].y;
          this.gameAnswered[`g${gIdx}`].answerPos = this.gameStarted;
        }
        if (!gameAnswer) {
          if (this.errorSound && this.errorSound.duration > 0 && !this.errorSound.paused) {
            this.errorSound.pause();
            this.errorSound.currentTime = 0;
          }
          setTimeout(() => {
            try {
              this.errorSound.play();
            } catch (err) {
              console.log(err.message); // eslint-disable-line
            }
          });
          setTimeout(() => {
            this.wrongAnswer = true;
            setTimeout(() => {
              this.wrongAnswerAn = true;
            }, 100);
          }, 500);
        } else {
          this.score += 100 / this.gameItems.length;
          if (this.okSound && this.okSound.duration > 0 && !this.okSound.paused) {
            this.okSound.pause();
            this.okSound.currentTime = 0;
          }
          setTimeout(() => {
            try {
              this.okSound.play();
            } catch (err) {
              console.log(err.message); // eslint-disable-line
            }
          });
          if (this.score >= 100) {
            // Save the game
            this.score = 100;
            this.btnLoading = true;
            const { contentId } = this.$route.params;
            this.$http.get(this.$config.uri(`content/game/${contentId}/finish`)).then((r) => {
              this.btnLoading = false;
            });
          }
        }
      }
      this.stopGame();
    },
    stopGame() {
      this.gameStarted = false;
      this.currentGame = 0;
      this.currentGameLr = '';
      document.getElementsByTagName('BODY')[0].classList.remove('noScroll');
    },
    clearHover() {
      this.gamePos.l1.hover = false;
      this.gamePos.r1.hover = false;
      this.gamePos.l2.hover = false;
      this.gamePos.r2.hover = false;
      this.gamePos.l3.hover = false;
      this.gamePos.r3.hover = false;
      this.gamePos.l4.hover = false;
      this.gamePos.r4.hover = false;
    },
    mouseMoved(e) {
      if (!this.gameStarted) return;
      this.clearHover();
      const xy = { x: 0, y: 0 };
      if (e.offsetX && e.offsetY) {
        xy.x = e.offsetX;
        xy.y = e.offsetY;
      } else {
        const rect = this.$refs.mouseMover.getBoundingClientRect();
        xy.x = e.targetTouches[0].pageX - rect.left;
        xy.y = e.targetTouches[0].pageY - rect.top;
      }
      // Snap to grid
      if (xy.x > this.gamePos.l1.x - 20
        && xy.x < this.gamePos.l1.x + 20
        && xy.y > this.gamePos.l1.y - 20
        && xy.y < this.gamePos.l1.y + 20) {
        this.gamePos.l1.hover = true;
        this.currentMouse.x = this.gamePos.l1.x;
        this.currentMouse.y = this.gamePos.l1.y;
        this.currentAnswer = 'l1';
      } else if (xy.x > this.gamePos.r1.x - 20
        && xy.x < this.gamePos.r1.x + 20
        && xy.y > this.gamePos.r1.y - 20
        && xy.y < this.gamePos.r1.y + 20) {
        this.gamePos.r1.hover = true;
        this.currentMouse.x = this.gamePos.r1.x;
        this.currentMouse.y = this.gamePos.r1.y;
        this.currentAnswer = 'r1';
      } else if (xy.x > this.gamePos.l2.x - 20
        && xy.x < this.gamePos.l2.x + 20
        && xy.y > this.gamePos.l2.y - 20
        && xy.y < this.gamePos.l2.y + 20) {
        this.gamePos.l2.hover = true;
        this.currentMouse.x = this.gamePos.l2.x;
        this.currentMouse.y = this.gamePos.l2.y;
        this.currentAnswer = 'l2';
      } else if (xy.x > this.gamePos.r2.x - 20
        && xy.x < this.gamePos.r2.x + 20
        && xy.y > this.gamePos.r2.y - 20
        && xy.y < this.gamePos.r2.y + 20) {
        this.gamePos.r2.hover = true;
        this.currentMouse.x = this.gamePos.r2.x;
        this.currentMouse.y = this.gamePos.r2.y;
        this.currentAnswer = 'r2';
      } else if (xy.x > this.gamePos.l3.x - 20
        && xy.x < this.gamePos.l3.x + 20
        && xy.y > this.gamePos.l3.y - 20
        && xy.y < this.gamePos.l3.y + 20) {
        this.gamePos.l3.hover = true;
        this.currentMouse.x = this.gamePos.l3.x;
        this.currentMouse.y = this.gamePos.l3.y;
        this.currentAnswer = 'l3';
      } else if (xy.x > this.gamePos.r3.x - 20
        && xy.x < this.gamePos.r3.x + 20
        && xy.y > this.gamePos.r3.y - 20
        && xy.y < this.gamePos.r3.y + 20) {
        this.gamePos.r3.hover = true;
        this.currentMouse.x = this.gamePos.r3.x;
        this.currentMouse.y = this.gamePos.r3.y;
        this.currentAnswer = 'r3';
      } else if (xy.x > this.gamePos.l4.x - 20
        && xy.x < this.gamePos.l4.x + 20
        && xy.y > this.gamePos.l4.y - 20
        && xy.y < this.gamePos.l4.y + 20) {
        this.gamePos.l4.hover = true;
        this.currentMouse.x = this.gamePos.l4.x;
        this.currentMouse.y = this.gamePos.l4.y;
        this.currentAnswer = 'l4';
      } else if (xy.x > this.gamePos.r4.x - 20
        && xy.x < this.gamePos.r4.x + 20
        && xy.y > this.gamePos.r4.y - 20
        && xy.y < this.gamePos.r4.y + 20) {
        this.gamePos.r4.hover = true;
        this.currentMouse.x = this.gamePos.r4.x;
        this.currentMouse.y = this.gamePos.r4.y;
        this.currentAnswer = 'r4';
      } else {
        this.currentMouse.x = xy.x;
        this.currentMouse.y = xy.y;
        this.currentAnswer = null;
      }
    },
    copyToClp(txt2copy) {
      const m = document;
      const txt = m.createTextNode(txt2copy);
      const w = window;
      const b = m.body;
      b.appendChild(txt);
      if (b.createTextRange) {
        const d = b.createTextRange();
        d.moveToElementText(txt);
        d.select();
        m.execCommand('copy');
      } else {
        const d = m.createRange();
        const g = w.getSelection;
        d.selectNodeContents(txt);
        g().removeAllRanges();
        g().addRange(d);
        m.execCommand('copy');
        g().removeAllRanges();
      }
      txt.remove();
      this.$refs.snackbar.open({ content: 'Link copied to clipboard.' });
    },
  },
  mounted() {
    // Check login
    if (!this.$session.get('bk6_email')) {
      this.$router.push('/login');
      return;
    }
    this.$http.get(this.$config.uri('user/status')).then((r) => {
      if (r.data.status !== 200) {
        this.$session.destroy();
        this.$router.push('/login');
      }
    });
    this.okSound = new Audio(`${this.$config.cdnUri2}media/audio/trueorfalse-true.mp3`);
    this.errorSound = new Audio(`${this.$config.cdnUri2}media/audio/trueorfalse-false.mp3`);
    const { contentId } = this.$route.params;
    this.$http.get(this.$config.uri(`content/${contentId}/game?fc=1`)).then((r) => {
      this.loading = false;
      this.title = (r.data.status === 200 && r.data.title) ? r.data.title : 'Game Cocokan Kata';
      this.gameItems = (r.data.status === 200) ? r.data.data : [];
      this.words = (r.data.status === 200) ? r.data.words : [];
      setTimeout(() => {
        const pr = this.$refs.gameCnt.getBoundingClientRect();
        if (this.$refs.r1) {
          const r1 = this.$refs.r1.getBoundingClientRect();
          this.gamePos.r1.x = (r1.left - pr.left) + 20;
        }
        if (this.$refs.r2) {
          const r2 = this.$refs.r2.getBoundingClientRect();
          this.gamePos.r2.x = (r2.left - pr.left) + 20;
        }
        if (this.$refs.r3) {
          const r3 = this.$refs.r3.getBoundingClientRect();
          this.gamePos.r3.x = (r3.left - pr.left) + 20;
        }
        if (this.$refs.r4) {
          const r4 = this.$refs.r4.getBoundingClientRect();
          this.gamePos.r4.x = (r4.left - pr.left) + 20;
        }
      });
    });
  },
};
</script>

<style scoped lang="scss">
.section.gameSection{
  position: relative;
  @media (max-width: 480px) {
    background-color: #fff;
    height: calc(100vh - 60px);
  }
  &:before{
    @media (max-width: 480px) {
      content: "";
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      background-image: url(../assets/game-bg-pattern.png);
      background-size: cover;
      background-position: center;
      opacity: .09;
    }
  }
}
.header{
  padding: 16px 20px 0;
  position: relative;
  z-index: 7;
  @media (min-width: 480px) {
    padding-left: 10px;
  }
  .backBtn{
    width: 46px; height: 46px;
    border-radius: 50%;
    background-color: #fff;
    background-image: url(../assets/arrow-back.png);
    background-size: 22px auto;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      background-color: #f5f5f5;
    }
  }
  h4{
    font-size: 22px;
    margin: 16px 0 6px;
    color: #006519;
  }
}
.profilePict{
  width: 94px; height: 94px;
  background-color: #ccc;
  border-radius: 50%;
  margin: 0 auto 16px;
  background-image: url(../assets/bruno-mars.jpg);
  background-position: center;
  background-size: cover;
}
.profileInfo{
  text-align: center;
  padding-bottom: 20px;
  h4{
    margin: 0;
    font-size: 20px;
  }
  p{
    margin: 0;
    font-size: 15px;
  }
}
.expCnt{
  background-color: rgba(255, 255, 255, .5);
  margin: 0 10px 10px;
  border-radius: 10px;
  padding: 16px 20px 20px;
  position: relative;
  h4{
    margin: 0 0 6px;
    font-size: 16px;
  }
  .expLabel{
    position: absolute;
    right: 20px; top: 18px;
    font-size: 14px;
  }
  .theExp{
    height: 12px;
    background-color: #ccc;
    border-radius: 50px;
    .exp{
      height: 100%;
      max-width: 100%;
      background-color: #8EC642;
      // background-color: #6aa722;
      border-radius: 50px;
    }
  }
  .info{
    font-size: 12px;
    color: #555;
    text-align: right;
    margin: 5px 5px 0;
  }
}

.selectorCnt{
  display: flex;
  justify-content: center;
  @media (max-height: 680px) {
    // justify-content: space-between;
  }
  .selectorItem{
    padding: 14px 34px 10px;
    border: #fff 1px solid;
    border-radius: 5px;
    transition: all .2s ease;
    position: relative;
    text-align: center;
    color: #444;
    padding: 14px 10px 10px;
    @media (max-height: 680px) {
      padding: 14px 10px 10px;
    }
    &:hover{
      opacity: 1;
      // border-color: #f5f5f5;
      // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
      cursor: pointer;
      background-color: #f5f5f5;
    }
    h4{
      margin: 0;
      font-size: 14px;
      font-weight: 600;
      color: #006519;
      font-size: 12px;
    }
    img{
      height: 30px;
      margin-bottom: 5px;
    }
  }
}

.downloadCnt{
  text-align: center;
}
.download{
  background-color: #8EC642;
  color: #fff;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 3px;
  // box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
  display: inline-block;
  text-align: center;
  // font-weight: bold;
  margin-top: 10px;
  padding-left: 48px;
  position: relative;
  &:before{
    position: absolute;
    content: "";
    left: 14px; top: 5px;
    width: 24px; height: 24px;
    background-image: url(../assets/download-o-white.png);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}
.shareLink{
  margin: 10px 10px 4px;
  background-color: #f5f5f5;
  border: #ccc 1px solid;
  border-radius: 3px;
  color: #222;
  padding: 10px 12px;
  position: relative;
  padding-right: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: normal;
  .copy{
    position: absolute;
    right: 4px; top: 4px;
    font-weight: 600;
    color: #005ab5;
    padding: 6px 10px;
    border-radius: 3px;
    cursor: pointer;
    &:hover{
      background-color: #ddd;
    }
  }
}

.menuCnt{
  padding: 10px 0;
  position: relative;
  z-index: 7;
  background-color: #f7ffd1;
  background-color: #fff;
  border-radius: 5px;
  margin-top: 10px;
  @media (max-width: 540px) {
    padding: 0 0 10px;
    margin-top: 0;
  }
  @media (max-width: 480px) {
    background: none;
  }
  &:before{
    content: "";
    position: absolute;
    left: 0; top: 0; right: 0; bottom: 0;
    background-image: url(../assets/game-bg-pattern.png);
    background-size: cover;
    background-position: center;
    opacity: .09;
    @media (max-width: 480px) {
      display: none;
    }
  }
  h4{
    margin: 0 20px 6px;
  }
  .divider{
    height: 20px;
  }
  .wrongAnswerCnt{
    position: fixed;
    left: 0; right: 0; bottom: 0; top: 0;
    background-color: rgba(255, 255, 255, .56);
    backdrop-filter: blur(14px);
    z-index: 9;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    color: red;
    opacity: 0;
    transition: all .3s ease;
    .wrongIn{
      transform: scale(.8);
      transition: all .3s ease;
      img{
        height: 120px;
      }
      h4{
        margin: 0 0 40px;
      }
    }
    &.open{
      opacity: 1;
      .wrongIn{
        transform: none;
      }
    }
  }
  .menuItem{
    padding: 16px 20px;
    font-weight: bold;
    color: #444;
    position: relative;
    margin: 0 10px;
    border-radius: 5px;
    font-size: 17px;
    box-sizing: border-box;
    &.report{
      padding: 16px 10px 0;
      text-align: center;
      .gameItemCnt{
        position: relative;
        svg{
          position: absolute;
          left: 0; top: 0;
          width: 100%; height: 100%;
          z-index: 1;
          line{
            stroke: #999;
            &.answerRight{
              stroke: #70be09;
            }
            &.answerWrong{
              stroke: red;
            }
          }
        }
        .mouseMover{
          position: absolute;
          left: 0; top: 0;
          width: 100%; height: 100%;
          z-index: 7;
        }
      }
      .gameItem{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        position: relative;
        z-index: 3;
        .gameItem1{
          &.gmImg{
            width: 100px; height: 100px;
            border-radius: 14px;
            position: relative;
            background-color: #aaa;
            .theImg{
              position: absolute;
              left: 5px; right: 5px; top: 5px; bottom: 5px;
              background-color: #fff;
              border-radius: 10px;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 16px;
              background-size: cover;
              background-position: center;
              &.canZoom{
                cursor: pointer;
              }
              .mediaLabel{
                font-size: 10px;
                border-radius: 0 0 10px 10px;
                color: #fff;
                font-weight: 500;
                position: absolute;
                left: 0; right: 0; bottom: 0;
                // background-color: #000;
                // background-color: rgba(0, 0, 0, .6);
                background-image: linear-gradient(transparent, rgba(0,0,0,.6));
                text-align: left;
                padding: 24px 6px 4px;
                line-height: 1.1;
              }
              &.smallFont{
                font-size: 13px;
                line-height: 1.1;
              }
              &.noImg{
                background-color: #fff;
                background-image: url(../assets/image-black.png);
                background-size: 36px auto;
                background-repeat: no-repeat;
                opacity: .35;
              }
            }
          }
          .gameHandle{
            width: 40px; height: 40px;
            border-radius: 50%;
            position: absolute;
            top: 50%; right: -42px;
            margin-top: -20px;
            transition: all .3s ease;
            cursor: pointer;
            &.hover, &:hover{
              background-color: #ccc;
            }
            &:before{
              width: 12px; height: 12px;
              background-color: #999;
              border-radius: 50%;
              position: absolute;
              content: "";
              left: 50%; top: 50%;
              margin: -6px 0 0 -6px;
            }
          }
          &.gameItem2{
            .gameHandle{
              right: auto;
              left: -42px;
            }
          }
          &.rightAnswer{
            &.gmImg{
              background-image: linear-gradient(-30deg, #70be09, #d1ff96);
              &:after{
                position: absolute;
                content: "";
                right: -10px; top: -10px;
                width: 32px; height: 32px;
                background-image: url(../assets/checked-green.png);
                background-size: 32px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            .gameHandle{
              background-color: transparent;
              &:before{
                background-color: #70be09;
              }
            }
          }
          &.wrongAnswer{
            &.gmImg{
              background-image: linear-gradient(-30deg, red, #ff7600);
              &:after{
                position: absolute;
                content: "";
                right: -10px; top: -10px;
                width: 32px; height: 32px;
                background-image: url(../assets/error.png);
                background-size: 32px auto;
                background-position: center;
                background-repeat: no-repeat;
              }
            }
            .gameHandle{
              background-color: transparent;
              &:before{
                background-color: red;
              }
            }
          }
        }
      }
      .gameHeader{
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        .menuBtn{
          width: 40px; height: 40px;
          background-color: #78C90E;
          background-image: linear-gradient(-30deg, #70be09, #d1ff96);
          border-radius: 10px;
          border: #006519 2px solid;
          box-sizing: border-box;
          transition: all .3s ease;
          cursor: pointer;
          display: none;
          &:hover{
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          }
        }
        .scoreCnt{
          display: flex;
          align-items: center;
          .scoreLabel{
            margin-right: 10px;
            font-size: 16px;
            @media (max-width: 680px) {
              margin-right: 6px;
            }
          }
          .score{
            background-color: #78C90E;
            background-image: linear-gradient(-30deg, #70be09, #d1ff96);
            border-radius: 60px;
            font-size: 22px;
            border: #006519 2px solid;
            box-sizing: border-box;
            padding: 4px 16px;
            color: #006519;
            @media (max-width: 680px) {
              font-size: 18px;
              padding: 4px 14px;
            }
          }
        }
        .progressCnt{
          width: 60%;
          margin-right: auto;
          background-color: #c4d6c6;
          border-radius: 50px;
          height: 12px;
          .progress{
            height: 12px;
            background-color: #70be09;
            border-radius: 50px;
            transition: all .7s ease;
          }
        }
      }
      .gameFooter{
        padding: 20px 0 20px;
        // display: flex;
        // justify-content: space-between;
        .btn{
          background-image: linear-gradient(-30deg, #70be09, #beff6b);
          width: 100%;
          // width: calc(50% - 10px);
          color: #006519;
          padding: 0;
          height: 44px;
          border-radius: 5px;
          line-height: 44px;
          &.btnLoading{
            background-color: #ccc !important;
          }
          &:hover{
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          }
          &.disabled{
            background: none;
            background-color: #ccc !important;
            cursor: default;
            box-shadow: none;
          }
        }
      }
    }
    img.imgReport{
      width: 100%;
      margin-bottom: 16px;
    }
    .loadingPrice{
      height: 40px;
      background-color: rgba(255, 255, 255, 0.5);
      background-color: transparent;
      background-image: url(../assets/loading.svg);
      background-position: center;
      background-repeat: no-repeat;
      background-size: 36px auto;
      height: 300px;
    }
    &.loading{
      text-align: center;
      color: #767676;
      // padding-bottom: 40px;
      h4{
        margin: 0 0 2px;
        font-size: 20px;
      }
      p{
        margin: 0;
        font-weight: normal;
        font-size: 15px;
      }
    }
    .bcCnt{
      display: flex;
      flex-wrap: wrap;
      padding-top: 8px;
      @media (max-width: 410px) {
        margin-bottom: -10px;
      }
      .bcItem{
        font-size: 13px;
        font-weight: normal;
        width: 32%;
        color: #767676;
        @media (max-width: 410px) {
          width: 50% !important;
          margin-bottom: 10px;
        }
        &.weight{
          width: 26%;
        }
        &.bmi{
          width: 21%;
        }
        span{
          display: block;
          font-weight: bold;
          font-size: 20px;
          color: #444;
        }
      }
    }
    .photoCnt{
      display: flex;
      margin: 0 -5px;
      padding-top: 8px;
      .photoItem{
        width: calc(33.3333% - 10px);
        margin: 0 5px;
        .thePhotoImgCnt{
          position: relative;
          height: 127px;
          overflow: hidden;
          background-color: #eee;
          border-radius: 5px;
          .thePhotoImg{
            cursor: pointer;
            position: absolute;
            max-width: 100%;
            max-height: 100%;
            top: -9999px;
            left: -9999px;
            right: -9999px;
            bottom: -9999px;
            margin: auto;
          }
        }
        .thePhoto{
          border-radius: 5px;
          background-color: #222;
          height: 126px;
          background-position: center;
          background-size: cover;
        }
        h4{
          font-size: 14px;
          margin: 4px 0 0;
          text-align: center;
        }
      }
    }
  }
}

</style>
